import { CaseDto } from '../models/contracts/project-dto';

export const getCasesWithNonZeroProbability = (cases: CaseDto[]): CaseDto[] =>
  cases.filter((c) => c.probability && c.probability !== 0);
